import {Component} from "react";
import "./TsrServicesListStyles.css"
import Fade from 'react-reveal/Fade';

class TsrServicesList extends Component {
    render() {
        return(
            <div className={"tsr-services-list"}>
                <ul className={"tsr-services-list_list"}>
                    <Fade left duration={1000}>
                        <li className={"tsr-services-list_item"}>Расчет компенсации за приобретённое ТСР<div className={"tsr-services-list_item_border"}></div></li>
                    </Fade>
                    <Fade left duration={2000}>
                        <li className={"tsr-services-list_item"}>Поиск точек приема электронного <br/> сертификата ТСР<div className={"tsr-services-list_item_border"}></div></li>
                    </Fade>
                    <Fade left duration={3000}>
                        <li className={"tsr-services-list_item"}>Множество справочной информации<div className={"tsr-services-list_item_border"}></div></li>
                    </Fade>
                </ul>
            </div>
        );
    }
}
export default TsrServicesList;